// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".venue-map {\n  border-radius: 6px;\n  background-color: #f2f2f2;\n}\n.map-legend {\n  border-radius: 3px;\n  background-color: white;\n  border: 3px solid #f2f2f2;\n  border-top: none;\n  border-bottom-left-radius: 6px;\n  border-bottom-right-radius: 6px;\n  padding: 1.5rem 2.5rem;\n}\n.map-legend h3 {\n  font-size: 1.5rem;\n}\n.map-legend p {\n  font-size: 16px;\n  margin-bottom: 0px;\n}\n.vue-map-container .vue-map {\n  border-radius: 6px;\n}", ""]);
// Exports
module.exports = exports;
